import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

const TEST_NAME = 'RemoveHolidayShipping_H22024';

export function getHolidayShippingAbTestVariant(): string | null {
    const abTestConfig = getAbTestV2(TEST_NAME);

    const variant = abTestConfig?.variant;

    if (!variant) {
        return null;
    }

    return variant;
}

export function trackHolidayShippingAbTestVariant(): void {
    trackAbTestV2Variant(TEST_NAME);
}
